export const styles = {
  card: {
    borderRadius: '8px',
    background: 'primary.light',
    boxShadow: 'none',
    minHeight: '100px',
  },
  lowStockCard: {
    borderRadius: '8px',
    background: 'primary.light',
    boxShadow: 'none',

    border: '1px solid #F7CA77',
  },
  itemContainer: {
    cursor: 'default',
    display: 'flex',
    position: 'relative',
    marginLeft: '10px',
  },
  topContainer: {
    background: '#F7CA77',
    padding: '10px',
  },
  topContainerLabel: {
    color: '#242528',
    fontWeight: 500,
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
  },
  content: {
    width: { xs: '85%', md: '95%' },
    paddingLeft: '15px',
    display: 'flex',
    gap: '8px',
    flexDirection: 'column',
    paddingRight: '5px',
    pt: '5px',
  },
  modContainer: {
    marginBottom: '5px',
  },
  modLadt: {
    mt: '3px',
    marginBottom: '50px',
    cursor: 'pointer',
  },
  modItems: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'baseline',
  },
  actionContainer: {
    display: 'flex',
    bottom: '15px',
    right: '5px',
    cursor: 'pointer',
    Height: '100%',
    // marginTop: '10px',
  },
  contentContainer: { display: 'flex', justifyContent: 'space-between', cursor: 'default', width: '100%' },

  outStockWarning: {
    color: 'warning.main',
    fontSize: '14px',
    fontWeight: '400',
  },
  snackbar: {
    backgroundColor: '#323232CC',
    width: '90%',
    m: '0px auto',
    color: 'grey.200',
    p: '5px 0px',
    borderRadius: '8px',
    position: 'fixed',
    bottom: '85px',
  },
  priceLabel: {
    borderRadius: { xs: '5px', md: '50px' },
    width: '56px',
    height: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: { xs: '12px', md: '14px' },
    fontWeight: '400',
    lineHeight: '18px',
    textTransform: 'capitalize',
    background: '#66DCA7',
  },
};
